import Command from "@ckeditor/ckeditor5-core/src/command";
import randomUUIDGenerator from "../../src/utils/randomUUIDGenerator";
import { CkeditorConstants } from '../../src/utils/ckeditorconstants';

const { htmlElement: { VIDEO, HTML_SPAN, PARAGRAPH, SPAN },
  class: { WK_KEYWORD_REF, REF },
  localStorageItem: { IS_LI_TAG_UP_FOR_SUB_TEMP_INSERTION, SUB_TEMPLATE_INSERTED_GUID, DATA_UNLOCK_SECTION },
  helperAttributes: { SUBTEMPLATE_NAME, TRACK_CHANGES_EDITING }, htmlAttributes: { ID, CLASS, LIST_TYPE, LIST_ITEM_ID, LIST_STYLE } } = CkeditorConstants;

export default class InsertSubtemplateCommand extends Command {
  execute({ value }) {
    this.editor.fire("insertsubtemplate");
    const editor = this.editor;
    const subtemplateInsertedGuid = randomUUIDGenerator();
    const trackChanges = editor.plugins.get(TRACK_CHANGES_EDITING);
    localStorage.setItem(SUB_TEMPLATE_INSERTED_GUID, subtemplateInsertedGuid);
    editor.model.change((writer) => {
      let countAllowedFortheTemplate = 0;
      let hypenIndex = value.count.indexOf("-");
      if (hypenIndex <= -1 && value.count !== "n") {
        countAllowedFortheTemplate = value.count;
      }
      const isLiTagUpForSubTempInsertion = localStorage.getItem(IS_LI_TAG_UP_FOR_SUB_TEMP_INSERTION);
      const isDataUnlockSection = localStorage.getItem(DATA_UNLOCK_SECTION);
      if (isLiTagUpForSubTempInsertion) {
        value.subtemplateContent = `<li>` + value.subtemplateContent + `</li>`
      }

      const subtemplateContentHTML = new DOMParser().parseFromString(
        value.subtemplateContent,
        "text/html"
      );

      const sectionContentEleList = subtemplateContentHTML.body.querySelectorAll(
        ".section-content"
      );
      const pTagInsideNoOne = subtemplateContentHTML.body.querySelectorAll(
        `[data-unlock='NO-ONE'] > p`
      );
      const asideEle = subtemplateContentHTML.body.querySelectorAll(
        "aside"
      );
      asideEle.forEach((item) => {
        item.setAttribute(
          "data-subtemplates-inserted",
          subtemplateInsertedGuid
        );
      });
      const sectionEle = subtemplateContentHTML.body.querySelectorAll(
        "section"
      );
      sectionEle.forEach((item) => {
        item.setAttribute(
          "data-subtemplates-inserted",
          subtemplateInsertedGuid
        );
      });
      sectionContentEleList.forEach((sectionContentEle) => {
        if (sectionContentEle.outerText.trim() === "") {
          sectionContentEle.append(document.createElement("p"));
        }
      });
      pTagInsideNoOne.forEach((pTag) => {
        writer.setAttribute("data-noone", randomUUIDGenerator(), pTag);
      });

      const { body: { innerHTML, children } } = subtemplateContentHTML;
      value.subtemplateContent = innerHTML.toString();
      const element = subtemplateContentHTML.body.querySelector(`[${SUBTEMPLATE_NAME}]`);
      this.subtemplateContentId = element?.getAttribute(ID);
      const isSpanSubtemplate = children[0].nodeName.toLowerCase() === SPAN && children[0].hasAttribute(SUBTEMPLATE_NAME);
      this.getAttributesForAll(editor.model.schema);
      if (countAllowedFortheTemplate !== 0) {
        let subtemplateContent = [];
        let pAndSubtempArrlen =
          +countAllowedFortheTemplate + 1 + +countAllowedFortheTemplate;

        for (let i = 0; i < pAndSubtempArrlen; i++) {
          if (i % 2 !== 0) {
            subtemplateContent.push(value.subtemplateContent);
          } else if (i % 2 === 0) {
            if (isDataUnlockSection) {
              subtemplateContent.push(
                `<div data-noone="${randomUUIDGenerator()}"></div>`
              );
            } else {
              subtemplateContent.push(
                `<p></p>`
              );
            }
          }
        }
        value.subtemplateContent = subtemplateContent
          .toString()
          .replace(/>,</g, '><')
      } else {
        if (isDataUnlockSection) {
          if (!isLiTagUpForSubTempInsertion) {
            value.subtemplateContent =
              `<div data-noone="${randomUUIDGenerator()}"></div>` +
              value.subtemplateContent +
              `<div data-noone="${randomUUIDGenerator()}"></div>`;
          }
        } else {
          if (!isLiTagUpForSubTempInsertion && !isSpanSubtemplate) {
            value.subtemplateContent =
              `<p></p>` +
              value.subtemplateContent +
              `<p></p>`;
          }
        }
      }

      const viewFragment = editor.data.processor.toView(
        value.subtemplateContent
      );
      const modelFragment = editor.data.toModel(viewFragment);
      for (const item of modelFragment.getChildren()) {
        if (item.name === PARAGRAPH && item.hasAttribute(HTML_SPAN)) {
          this.editor.model.change(writer => {
            writer.unwrap(item)
          })
        }
      }
      if (isDataUnlockSection) {
        const range = editor.model.createRangeIn(
          editor.model.document.getRoot()
        );
        const dataUnlockSectionItems = [];
        for (const item of range.getItems({ ignoreElementEnd: true })) {
          if (
            item.getAttribute("data-noone") &&
            item.getAttribute("data-noone") ===
            isDataUnlockSection
          ) {
            dataUnlockSectionItems.push(item);
          }
        }

        for (let i = 0; i < dataUnlockSectionItems.length; i++) {
          writer.setAttribute(
            "contenteditable",
            "true",
            dataUnlockSectionItems[i]
          );
          if (
            dataUnlockSectionItems[i].name === "div" &&
            dataUnlockSectionItems[i].hasAttribute("data-noone") &&
            !dataUnlockSectionItems[i].hasAttribute("data-subtemplates-allow")
          ) {
            if (this.editor.commands.get('trackChanges').value && this.editor.plugins.get('TrackChanges').isEnabled) {
              const pos = writer.createPositionBefore(dataUnlockSectionItems[i]);
              writer.setSelection(pos);
              writer.remove(dataUnlockSectionItems[i])
            } else {
              writer.setSelection(dataUnlockSectionItems[i], "on");
            }
          } else {
            if (!isLiTagUpForSubTempInsertion) {
              writer.setSelection(dataUnlockSectionItems[i], "in");
            } else {
              writer.setSelection(dataUnlockSectionItems[i], "after");
            }
          }

          editor.model.insertContent(modelFragment);

          writer.setAttribute(
            "contenteditable",
            "false",
            dataUnlockSectionItems[i]
          );
          const range = editor.model.createRangeIn(dataUnlockSectionItems[i]);
          for (const value of range.getWalker()) {
            if (value.item.name !== "header") {
              writer.setAttribute("contenteditable", "true", value.item);
            }
          }
        }
        localStorage.removeItem("dataUnlockSection");
      } else {
        // check for inserted IST children elements
        const inlineSubtemplatePosition = [];
        for (const item of modelFragment.getChildren()) {
          if (item?.hasAttribute(SUBTEMPLATE_NAME) && item?.getChild(1)) {
            inlineSubtemplatePosition.push(item.getChild(1))
          }
          else {
            for (const val of item.getChildren()) {
              if (val?.hasAttribute(SUBTEMPLATE_NAME) && val?.getChild(1)) {
                inlineSubtemplatePosition.push(val.getChild(1))
              }
            }
          }
        }
        const selection = this.editor.model.document.selection;
        //set selection after the keyword or Link then subtemplate will be inserted outside of keyword span tag
        const afterKeywordOrLink = selection.focus.nodeBefore;
        if ((afterKeywordOrLink?.parent?.hasAttribute(CLASS) && (afterKeywordOrLink.parent.getAttribute(CLASS) === WK_KEYWORD_REF || afterKeywordOrLink.parent.getAttribute(CLASS) === REF))) {
          writer.setSelection(afterKeywordOrLink.parent, 'after');
        }

        //set selection before Keyword or Link then subtemplate will be inserted or add before keyword  span tag
        const beforeKeywordOrLink = selection.focus.nodeAfter;
        if (beforeKeywordOrLink?.parent?.hasAttribute(CLASS) && beforeKeywordOrLink.parent.getAttribute(CLASS) === WK_KEYWORD_REF && !selection.focus.parent.parent.hasAttribute(LIST_TYPE)) {
          writer.setSelection(beforeKeywordOrLink.parent, 'before');
        } else {
          if (selection.focus.parent?.parent?.hasAttribute(LIST_TYPE)) {
            writer.setSelection(selection.focus.parent.parent, 'before');
          }
        }
        if (!selection.focus.nodeAfter && selection.anchor.parent.getAncestors().reverse().find(element => element.hasAttribute(LIST_TYPE))) {
          writer.setSelection(selection.focus.getAncestors().reverse().find(ele => ele.getAttribute(LIST_ITEM_ID)), 'after');
        }

        // Applying style of respective ul / ol tag back to it if subtemplate is inserted in li tag.
        if (isLiTagUpForSubTempInsertion === 'true') {
          // Get style of parent ul / ol tag
          const styleOfLiTagUpForSubTempInsertion = selection.focus.getAncestors().reverse().find(ele => ele.getAttribute(LIST_ITEM_ID)).getAttribute(LIST_STYLE);
          modelFragment.getChild(0)._setAttribute(LIST_STYLE, styleOfLiTagUpForSubTempInsertion);
        }

        selection.getFirstPosition()?.parent?.getChild(0)?.name === VIDEO ?
          editor.model.insertContent(modelFragment, writer.createSelection(selection.getFirstPosition().parent, "on"))
          :
          editor.model.insertContent(modelFragment);
        // Placement of cursor focus for IST
        if (inlineSubtemplatePosition.length > 0 && !this.subtemplateContentId) {
          const pos = writer.createPositionAt(inlineSubtemplatePosition[0], 'end');
          editor.focus();
          writer.setSelection(pos);
        }
      }
      editor.execute("toggleRestrictedEditing", {
        value: value.currentUserRoles,
        insertSubTemplate: true
      });
      editor.execute("toggleTemplateHoverAndSelect");
      localStorage.removeItem(SUB_TEMPLATE_INSERTED_GUID);
    });
  }

  getAttributesForAll(schema) {
    schema.addAttributeCheck((context) => {
      for (const element of InsertSubtemplateCommand.customModelElements) {
        if (context.endsWith(element)) {
          return true;
        }
      }
    });
  }
}

InsertSubtemplateCommand.customModelElements = [
  "aside",
  "section",
  "paragraph",
  "div",
  "header",
  "span",
  "heading1",
  "heading2",
  "heading3",
  "heading4",
  "heading5",
  "heading6",
  "citation",
  "numberedcitation",
];
